export var MAX_SEARCH_LENGTH=70;